export function formatCompanyLabel(company: {
    companyId: number | null;
    companyName: string;
}): string {
    const name = company.companyName.trim() || 'Unnamed company';
    return company.companyId == null ? name : `${name} (#${company.companyId})`;
}

export function formatTeamLabel(team: { teamId: number | null; teamName: string }): string {
    const name = team.teamName.trim() || 'Unnamed team';
    return team.teamId == null ? name : `${name} (#${team.teamId})`;
}
